import { useEffect } from "react";
import { triggerInstall } from "./installPrompt";

/**
 * useAutoInstall — when a donor/attendee lands with `?install=1` (e.g. by
 * scanning the "Add to phone" QR on a printed program or check-in screen),
 * surface the install path automatically:
 *   - Chromium (Android/desktop) with a deferred prompt → fire the native
 *     add-to-home-screen sheet immediately.
 *   - iOS / no prompt available → smooth-scroll the DonorInstallStrip into
 *     view so the "Install the {event} app" button (with its Share → Add to
 *     Home Screen instructions) is front and center.
 *
 * @param {boolean} active  pass the page's "data loaded" flag so the strip
 *                          exists in the DOM before we try to scroll to it.
 */
export function useAutoInstall(active) {
    useEffect(() => {
        if (!active || typeof window === "undefined") return undefined;
        const params = new URLSearchParams(window.location.search);
        if (params.get("install") !== "1") return undefined;

        let cancelled = false;
        const timer = setTimeout(async () => {
            if (cancelled) return;
            const res = await triggerInstall();
            if (res === "unavailable") {
                document
                    .querySelector('[data-testid="donor-install-strip"]')
                    ?.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        }, 1400);

        return () => { cancelled = true; clearTimeout(timer); };
    }, [active]);
}
